import { render, staticRenderFns } from "./PlayerBar.vue?vue&type=template&id=07f2e7c2&"
import script from "./PlayerBar.vue?vue&type=script&lang=js&"
export * from "./PlayerBar.vue?vue&type=script&lang=js&"
import style0 from "./PlayerBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports